/* eslint-disable @stylistic/max-statements-per-line */
import type { PropsWithChildren } from 'react';
import React, {
  createContext, useCallback, useContext, useMemo, useState,
} from 'react';

import type { NavbarType, NavbarContext } from './types';

const defaultNavbarCtx: NavbarContext = {
  type: 'expanded',
};
const NavbarTypeCtx = createContext<NavbarContext>(defaultNavbarCtx);

function NavbarContextProvider({ children }: PropsWithChildren): React.JSX.Element {
  const [type, setType] = useState<NavbarType>('expanded');

  const toggleType = useCallback(() => {
    switch (type) {
      case 'collapsed': setType('expanded'); break;
      case 'expanded': setType('collapsed'); break;
      default: throw new Error(`unknown type ${type}`);
    }
  }, [setType, type]);

  const ctx = useMemo(() => ({
    type,
    setType,
    toggleType,
  }), [type, setType, toggleType]);

  return (
    <NavbarTypeCtx.Provider value={ctx}>
      {children}
    </NavbarTypeCtx.Provider>
  );
}
const useNavbarContext = (): NavbarContext => useContext(NavbarTypeCtx);

export { NavbarContextProvider, useNavbarContext };
